import React from "react";

import { Box, Typography } from "@mui/material";

import { ErrorRounded } from "@mui/icons-material";

import { StyledButton } from "../../Button/StyledButton";

export const ServerError = ({
  goBack,
  refresh,
}: {
  goBack?: () => void;
  refresh?: () => void;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 3,
        maxWidth: 600,
        margin: "5% auto",
        textAlign: "center",
      }}
    >
      <ErrorRounded
        sx={({ palette }) => ({ color: palette.error.light })}
        fontSize={"large"}
      />
      <Typography variant={"h1"}>There's a problem</Typography>
      <Typography variant={"body1"}>
        The server encountered an error and could not complete your request.
      </Typography>
      <Typography variant={"body1"}>
        If the problem persist, please report your problem and mention the error
        message and query that caused it.
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
        }}
      >
        {goBack ? (
          <StyledButton
            label={"Go back"}
            variant={"outlined"}
            isOscarDesign
            onClick={goBack}
          />
        ) : null}
        {refresh ? (
          <StyledButton
            label={"Refresh"}
            variant={"contained"}
            isOscarDesign
            onClick={refresh}
          />
        ) : null}
      </Box>
    </Box>
  );
};
